var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-down",
    viewBox: "0 0 10 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.668805L5 5.24023L9 0.668805",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75L12.4875 12.4875",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6L15 12L9 18",
    stroke: "#C17E7E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevrons-right",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 15.5832L16.5001 10.9998L11.9167 6.4165",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.5832L10.0833 10.9998L5.5 6.4165",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18L9 12L15 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_17280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 3.3335H3.33341C2.89139 3.3335 2.46746 3.50909 2.1549 3.82165C1.84234 4.13421 1.66675 4.55814 1.66675 5.00016V16.6668C1.66675 17.1089 1.84234 17.5328 2.1549 17.8453C2.46746 18.1579 2.89139 18.3335 3.33341 18.3335H15.0001C15.4421 18.3335 15.866 18.1579 16.1786 17.8453C16.4912 17.5328 16.6667 17.1089 16.6667 16.6668V10.8335",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 2.0832C15.7483 1.75168 16.1979 1.56543 16.6667 1.56543C17.1356 1.56543 17.5852 1.75168 17.9167 2.0832C18.2483 2.41472 18.4345 2.86436 18.4345 3.3332C18.4345 3.80204 18.2483 4.25168 17.9167 4.5832L10.0001 12.4999L6.66675 13.3332L7.50008 9.99986L15.4167 2.0832Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_17280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 8,
    fill: "white"
  }))))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17987 3.33325H15.8994C16.7738 3.33325 17.4893 4.08325 17.4893 4.99992V14.9999C17.4893 15.9166 16.7738 16.6666 15.8994 16.6666H3.17987C2.30541 16.6666 1.58994 15.9166 1.58994 14.9999V4.99992C1.58994 4.08325 2.30541 3.33325 3.17987 3.33325Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4893 5L9.53962 10.8333L1.58994 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "cart",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_18964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15471 18.3334C7.59376 18.3334 7.94968 17.9603 7.94968 17.5001C7.94968 17.0398 7.59376 16.6667 7.15471 16.6667C6.71566 16.6667 6.35974 17.0398 6.35974 17.5001C6.35974 17.9603 6.71566 18.3334 7.15471 18.3334Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8994 18.3334C16.3384 18.3334 16.6944 17.9603 16.6944 17.5001C16.6944 17.0398 16.3384 16.6667 15.8994 16.6667C15.4604 16.6667 15.1044 17.0398 15.1044 17.5001C15.1044 17.9603 15.4604 18.3334 15.8994 18.3334Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.794983 0.833252H3.97486L6.10537 11.9916C6.17807 12.3752 6.37718 12.7199 6.66785 12.9652C6.95852 13.2104 7.32223 13.3407 7.69531 13.3333H15.4224C15.7955 13.3407 16.1592 13.2104 16.4499 12.9652C16.7405 12.7199 16.9396 12.3752 17.0123 11.9916L18.2843 4.99992H4.76983",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_18964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0792,
    height: 20,
    fill: "white"
  }))))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "profile",
    viewBox: "0 0 21 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1496 15.9069V14.3919C17.1496 13.5884 16.7984 12.8177 16.1732 12.2495C15.5481 11.6813 14.7003 11.3621 13.8162 11.3621H7.14956C6.2655 11.3621 5.41765 11.6813 4.79253 12.2495C4.16741 12.8177 3.81622 13.5884 3.81622 14.3919V15.9069",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4829 8.33222C12.3239 8.33222 13.8163 6.9757 13.8163 5.30234C13.8163 3.62898 12.3239 2.27246 10.4829 2.27246C8.64198 2.27246 7.1496 3.62898 7.1496 5.30234C7.1496 6.9757 8.64198 8.33222 10.4829 8.33222Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    id: "dashboard",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 2.375H2.375V7.91667H7.91667V2.375Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6249 2.375H11.0833V7.91667H16.6249V2.375Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6249 11.0835H11.0833V16.6252H16.6249V11.0835Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 11.0835H2.375V16.6252H7.91667V11.0835Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    id: "marketplace",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1.5835L2.375 4.75016V15.8335C2.375 16.2534 2.54181 16.6561 2.83875 16.9531C3.13568 17.25 3.53841 17.4168 3.95833 17.4168H15.0417C15.4616 17.4168 15.8643 17.25 16.1613 16.9531C16.4582 16.6561 16.625 16.2534 16.625 15.8335V4.75016L14.25 1.5835H4.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.375 4.75H16.625",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 7.9165C12.6666 8.75636 12.333 9.56181 11.7391 10.1557C11.1452 10.7495 10.3398 11.0832 9.49992 11.0832C8.66007 11.0832 7.85461 10.7495 7.26075 10.1557C6.66688 9.56181 6.33325 8.75636 6.33325 7.9165",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "irs-station",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5C13.435 9.5 16.625 8.43668 16.625 7.125C16.625 5.81332 13.435 4.75 9.5 4.75C5.56497 4.75 2.375 5.81332 2.375 7.125C2.375 8.43668 5.56497 9.5 9.5 9.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.375 7.521V15.3445C2.375 16.2722 5.54167 17.021 9.5 17.021C13.4583 17.021 16.625 16.2722 16.625 15.3445V7.521",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "clients",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_17461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4584 16.625V15.0417C13.4584 14.2018 13.1248 13.3964 12.5309 12.8025C11.9371 12.2086 11.1316 11.875 10.2917 11.875H3.95841C3.11856 11.875 2.31311 12.2086 1.71924 12.8025C1.12538 13.3964 0.791748 14.2018 0.791748 15.0417V16.625",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12492 8.70833C8.87382 8.70833 10.2916 7.29057 10.2916 5.54167C10.2916 3.79276 8.87382 2.375 7.12492 2.375C5.37602 2.375 3.95825 3.79276 3.95825 5.54167C3.95825 7.29057 5.37602 8.70833 7.12492 8.70833Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 16.6251V15.0418C18.2077 14.3401 17.9742 13.6586 17.5443 13.104C17.1145 12.5495 16.5126 12.1534 15.8333 11.978",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.47803C13.3479 2.65243 13.9517 3.04858 14.3828 3.60402C14.8139 4.15946 15.048 4.8426 15.048 5.54574C15.048 6.24887 14.8139 6.93201 14.3828 7.48745C13.9517 8.04289 13.3479 8.43904 12.6667 8.61344",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_17461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "currentColor"
  }))))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "orders",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 3.16675H14.2501C14.67 3.16675 15.0727 3.33356 15.3697 3.6305C15.6666 3.92743 15.8334 4.33016 15.8334 4.75008V15.8334C15.8334 16.2533 15.6666 16.6561 15.3697 16.953C15.0727 17.2499 14.67 17.4167 14.2501 17.4167H4.75008C4.33016 17.4167 3.92743 17.2499 3.6305 16.953C3.33356 16.6561 3.16675 16.2533 3.16675 15.8334V4.75008C3.16675 4.33016 3.33356 3.92743 3.6305 3.6305C3.92743 3.33356 4.33016 3.16675 4.75008 3.16675H6.33341",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8749 1.58325H7.12492C6.68769 1.58325 6.33325 1.93769 6.33325 2.37492V3.95825C6.33325 4.39548 6.68769 4.74992 7.12492 4.74992H11.8749C12.3121 4.74992 12.6666 4.39548 12.6666 3.95825V2.37492C12.6666 1.93769 12.3121 1.58325 11.8749 1.58325Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "data",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16675 15.4374C3.16675 14.9125 3.37527 14.4091 3.74643 14.0379C4.1176 13.6668 4.62101 13.4583 5.14591 13.4583H15.8334",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14591 1.58325H15.8334V17.4166H5.14591C4.62101 17.4166 4.1176 17.2081 3.74643 16.8369C3.37527 16.4657 3.16675 15.9623 3.16675 15.4374V3.56242C3.16675 3.03751 3.37527 2.5341 3.74643 2.16294C4.1176 1.79177 4.62101 1.58325 5.14591 1.58325V1.58325Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "logs",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_706_17458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50008 1.58341C5.12783 1.58342 1.58341 5.12783 1.58341 9.50008C1.58341 13.8723 5.12783 17.4167 9.50008 17.4167C13.8723 17.4167 17.4167 13.8723 17.4167 9.50008C17.4167 5.12783 13.8723 1.58341 9.50008 1.58341Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.6667L9.5 9.50008",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.33325L9.49136 6.33325",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_17458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "currentColor",
    transform: "translate(19 19) rotate(180)"
  }))))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_706_17453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.875C10.8117 11.875 11.875 10.8117 11.875 9.5C11.875 8.18832 10.8117 7.125 9.5 7.125C8.18832 7.125 7.125 8.18832 7.125 9.5C7.125 10.8117 8.18832 11.875 9.5 11.875Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3584 11.8751C15.253 12.1139 15.2216 12.3787 15.2682 12.6355C15.3147 12.8924 15.4372 13.1293 15.6197 13.3159L15.6672 13.3634C15.8144 13.5105 15.9312 13.6851 16.0108 13.8773C16.0905 14.0695 16.1315 14.2755 16.1315 14.4836C16.1315 14.6917 16.0905 14.8977 16.0108 15.0899C15.9312 15.2822 15.8144 15.4568 15.6672 15.6038C15.5201 15.751 15.3455 15.8678 15.1533 15.9475C14.9611 16.0272 14.755 16.0682 14.547 16.0682C14.3389 16.0682 14.1328 16.0272 13.9406 15.9475C13.7484 15.8678 13.5738 15.751 13.4267 15.6038L13.3792 15.5563C13.1927 15.3738 12.9557 15.2514 12.6989 15.2048C12.4421 15.1583 12.1772 15.1897 11.9384 15.2951C11.7043 15.3954 11.5046 15.5621 11.3639 15.7745C11.2232 15.9869 11.1478 16.2357 11.1467 16.4905V16.6251C11.1467 17.045 10.9799 17.4477 10.683 17.7447C10.3861 18.0416 9.98334 18.2084 9.56341 18.2084C9.14349 18.2084 8.74076 18.0416 8.44383 17.7447C8.1469 17.4477 7.98008 17.045 7.98008 16.6251V16.5538C7.97395 16.2918 7.88913 16.0377 7.73665 15.8245C7.58417 15.6113 7.37108 15.4489 7.12508 15.3584C6.8863 15.253 6.62143 15.2216 6.36462 15.2682C6.1078 15.3147 5.87083 15.4372 5.68425 15.6197L5.63675 15.6672C5.4897 15.8144 5.31508 15.9312 5.12286 16.0108C4.93065 16.0905 4.72461 16.1315 4.51654 16.1315C4.30846 16.1315 4.10243 16.0905 3.91022 16.0108C3.718 15.9312 3.54338 15.8144 3.39633 15.6672C3.24912 15.5201 3.13233 15.3455 3.05265 15.1533C2.97297 14.9611 2.93196 14.755 2.93196 14.547C2.93196 14.3389 2.97297 14.1328 3.05265 13.9406C3.13233 13.7484 3.24912 13.5738 3.39633 13.4267L3.44383 13.3792C3.62634 13.1927 3.74877 12.9557 3.79533 12.6989C3.8419 12.4421 3.81046 12.1772 3.70508 11.9384C3.60473 11.7043 3.4381 11.5046 3.2257 11.3639C3.0133 11.2232 2.76441 11.1478 2.50966 11.1467H2.37508C1.95516 11.1467 1.55243 10.9799 1.2555 10.683C0.958563 10.3861 0.791748 9.98334 0.791748 9.56341C0.791748 9.14349 0.958563 8.74076 1.2555 8.44383C1.55243 8.1469 1.95516 7.98008 2.37508 7.98008H2.44633C2.70837 7.97395 2.9625 7.88913 3.17569 7.73665C3.38888 7.58417 3.55127 7.37108 3.64175 7.12508C3.74713 6.8863 3.77857 6.62143 3.732 6.36462C3.68544 6.1078 3.56301 5.87083 3.3805 5.68425L3.333 5.63675C3.18579 5.4897 3.069 5.31508 2.98932 5.12286C2.90964 4.93065 2.86863 4.72461 2.86863 4.51654C2.86863 4.30846 2.90964 4.10243 2.98932 3.91022C3.069 3.718 3.18579 3.54338 3.333 3.39633C3.48005 3.24912 3.65467 3.13233 3.84688 3.05265C4.0391 2.97297 4.24513 2.93196 4.45321 2.93196C4.66128 2.93196 4.86731 2.97297 5.05953 3.05265C5.25174 3.13233 5.42637 3.24912 5.57341 3.39633L5.62091 3.44383C5.80749 3.62634 6.04447 3.74877 6.30128 3.79533C6.55809 3.8419 6.82297 3.81046 7.06175 3.70508H7.12508C7.35923 3.60473 7.55893 3.4381 7.69959 3.2257C7.84025 3.0133 7.91573 2.76441 7.91675 2.50966V2.37508C7.91675 1.95516 8.08356 1.55243 8.3805 1.2555C8.67743 0.958563 9.08015 0.791748 9.50008 0.791748C9.92001 0.791748 10.3227 0.958563 10.6197 1.2555C10.9166 1.55243 11.0834 1.95516 11.0834 2.37508V2.44633C11.0844 2.70108 11.1599 2.94997 11.3006 3.16237C11.4412 3.37476 11.6409 3.54139 11.8751 3.64175C12.1139 3.74713 12.3787 3.77857 12.6355 3.732C12.8924 3.68544 13.1293 3.56301 13.3159 3.3805L13.3634 3.333C13.5105 3.18579 13.6851 3.069 13.8773 2.98932C14.0695 2.90964 14.2755 2.86863 14.4836 2.86863C14.6917 2.86863 14.8977 2.90964 15.0899 2.98932C15.2822 3.069 15.4568 3.18579 15.6038 3.333C15.751 3.48005 15.8678 3.65467 15.9475 3.84688C16.0272 4.0391 16.0682 4.24513 16.0682 4.45321C16.0682 4.66128 16.0272 4.86731 15.9475 5.05953C15.8678 5.25174 15.751 5.42637 15.6038 5.57341L15.5563 5.62091C15.3738 5.80749 15.2514 6.04447 15.2048 6.30128C15.1583 6.55809 15.1897 6.82297 15.2951 7.06175V7.12508C15.3954 7.35923 15.5621 7.55893 15.7745 7.69959C15.9869 7.84025 16.2357 7.91573 16.4905 7.91675H16.6251C17.045 7.91675 17.4477 8.08356 17.7447 8.3805C18.0416 8.67743 18.2084 9.08015 18.2084 9.50008C18.2084 9.92001 18.0416 10.3227 17.7447 10.6197C17.4477 10.9166 17.045 11.0834 16.6251 11.0834H16.5538C16.2991 11.0844 16.0502 11.1599 15.8378 11.3006C15.6254 11.4412 15.4588 11.6409 15.3584 11.8751V11.8751Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_17453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "currentColor"
  }))))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_19680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.3332C14.6023 18.3332 18.3333 14.6022 18.3333 9.99984C18.3333 5.39746 14.6023 1.6665 9.99996 1.6665C5.39759 1.6665 1.66663 5.39746 1.66663 9.99984C1.66663 14.6022 5.39759 18.3332 9.99996 18.3332Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5L7.5 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L12.5 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_19680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkmark",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5L7.5 14.1667L3.33333 10",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "chat",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.75C19.25 14.2362 19.0568 14.7025 18.713 15.0464C18.3692 15.3902 17.9029 15.5833 17.4167 15.5833H6.41667L2.75 19.25V4.58333C2.75 4.0971 2.94315 3.63079 3.28697 3.28697C3.63079 2.94315 4.0971 2.75 4.58333 2.75H17.4167C17.9029 2.75 18.3692 2.94315 18.713 3.28697C19.0568 3.63079 19.25 4.0971 19.25 4.58333V13.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 5.00002V16.6667C15.8334 17.1087 15.6578 17.5326 15.3452 17.8452C15.0326 18.1578 14.6087 18.3334 14.1667 18.3334H5.83335C5.39133 18.3334 4.9674 18.1578 4.65484 17.8452C4.34228 17.5326 4.16669 17.1087 4.16669 16.6667V5.00002M6.66669 5.00002V3.33335C6.66669 2.89133 6.84228 2.4674 7.15484 2.15484C7.4674 1.84228 7.89133 1.66669 8.33335 1.66669H11.6667C12.1087 1.66669 12.5326 1.84228 12.8452 2.15484C13.1578 2.4674 13.3334 2.89133 13.3334 3.33335V5.00002",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 9.16669V14.1667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.16669V14.1667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "corner-up-left",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 11.6666L3.33331 7.49998L7.49998 3.33331",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16.6667V10.8333C16.6666 9.94928 16.3155 9.10143 15.6903 8.47631C15.0652 7.85119 14.2174 7.5 13.3333 7.5H3.33331",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 9.1665H4.16667C3.24619 9.1665 2.5 9.9127 2.5 10.8332V16.6665C2.5 17.587 3.24619 18.3332 4.16667 18.3332H15.8333C16.7538 18.3332 17.5 17.587 17.5 16.6665V10.8332C17.5 9.9127 16.7538 9.1665 15.8333 9.1665Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 9.1665V5.83317C5.83331 4.7281 6.2723 3.66829 7.0537 2.88689C7.8351 2.10549 8.89491 1.6665 9.99998 1.6665C11.105 1.6665 12.1649 2.10549 12.9463 2.88689C13.7277 3.66829 14.1666 4.7281 14.1666 5.83317V9.1665",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "unlock",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 9.16675H4.16667C3.24619 9.16675 2.5 9.91294 2.5 10.8334V16.6667C2.5 17.5872 3.24619 18.3334 4.16667 18.3334H15.8333C16.7538 18.3334 17.5 17.5872 17.5 16.6667V10.8334C17.5 9.91294 16.7538 9.16675 15.8333 9.16675Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83332 9.16679V5.83346C5.83228 4.80017 6.21522 3.80335 6.90779 3.03652C7.60037 2.26968 8.55317 1.78755 9.58124 1.6837C10.6093 1.57986 11.6393 1.86171 12.4712 2.47456C13.3031 3.0874 13.8777 3.9875 14.0833 5.00013",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_18877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833336 10C0.833336 10 4.16667 3.33337 10 3.33337C15.8333 3.33337 19.1667 10 19.1667 10C19.1667 10 15.8333 16.6667 10 16.6667C4.16667 16.6667 0.833336 10 0.833336 10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_18877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye-off",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_16759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7667 11.7666C11.5378 12.0122 11.2618 12.2092 10.9552 12.3459C10.6485 12.4825 10.3175 12.556 9.98178 12.5619C9.64611 12.5678 9.31268 12.5061 9.00138 12.3803C8.69009 12.2546 8.40731 12.0675 8.16991 11.8301C7.93252 11.5927 7.74537 11.3099 7.61963 10.9986C7.49389 10.6873 7.43215 10.3539 7.43807 10.0182C7.44399 9.68252 7.51746 9.35148 7.6541 9.04481C7.79074 8.73815 7.98775 8.46215 8.23337 8.23327M14.95 14.9499C13.5255 16.0358 11.791 16.6373 10 16.6666C4.16671 16.6666 0.833374 9.99994 0.833374 9.99994C1.86995 8.06819 3.30765 6.38045 5.05004 5.04994L14.95 14.9499ZM8.25004 3.53327C8.82365 3.39901 9.41093 3.33189 10 3.33327C15.8334 3.33327 19.1667 9.99994 19.1667 9.99994C18.6609 10.9463 18.0576 11.8372 17.3667 12.6583L8.25004 3.53327Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833374 0.833252L19.1667 19.1666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_16759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.75V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V13.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 9.16669L11 13.75L15.5833 9.16669",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.75V2.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "tag",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1582 11.1751L11.1832 17.1501C11.0284 17.305 10.8446 17.428 10.6422 17.5118C10.4399 17.5957 10.223 17.6389 10.004 17.6389C9.78498 17.6389 9.5681 17.5957 9.36577 17.5118C9.16344 17.428 8.97963 17.305 8.82484 17.1501L1.6665 10.0001V1.66675H9.99984L17.1582 8.82508C17.4686 9.13735 17.6428 9.55977 17.6428 10.0001C17.6428 10.4404 17.4686 10.8628 17.1582 11.1751V11.1751Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 5.83325H5.84183",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "green-checkmark",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4582 4.8166L6.38709 11.8877L2.54297 8.04356L3.25007 7.33645L6.38709 10.4735L12.751 4.1095L13.4582 4.8166Z",
    fill: "#8BE97C",
    stroke: "#8BE97C",
    strokeLinecap: "square"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_16182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53774 15.1578C0.76216 15.1578 0.420265 14.5945 0.777317 13.906L7.34953 1.25131C7.70658 0.562889 8.29184 0.562889 8.64932 1.25131L15.2215 13.906C15.5794 14.5945 15.2371 15.1578 14.4611 15.1578H1.53774Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06018 4.90941C7.06018 4.3612 7.46481 4.02183 7.99997 4.02183C8.5225 4.02183 8.94018 4.37425 8.94018 4.90941V9.93593C8.94018 10.4711 8.5225 10.8235 7.99997 10.8235C7.46481 10.8235 7.06018 10.4837 7.06018 9.93593V4.90941ZM6.98145 12.6117C6.98189 12.3418 7.08936 12.083 7.28028 11.8922C7.47121 11.7013 7.73002 11.594 7.99997 11.5936C8.26993 11.594 8.52873 11.7013 8.71966 11.8922C8.91059 12.083 9.01805 12.3418 9.0185 12.6117C9.01816 12.8817 8.91075 13.1406 8.71981 13.3316C8.52887 13.5225 8.27 13.6299 7.99997 13.6302C7.72994 13.6299 7.47107 13.5225 7.28013 13.3316C7.0892 13.1406 6.98178 12.8817 6.98145 12.6117Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_16182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "red-warning",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83632 1.94245C9.47692 0.833963 10.523 0.833963 11.1624 1.94245L19.4236 16.8758C20.0642 17.9831 19.5393 18.8891 18.26 18.8891H12.3272C11.0466 18.8891 8.95329 18.8891 7.67268 18.8891H1.73995C0.459953 18.8891 -0.0636832 17.9831 0.575105 16.8758L8.83632 1.94245Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 6.03638C9.23862 6.03638 8.39741 6.62607 8.47135 7.57698L9.09074 13.2406C9.11498 13.6327 9.23862 14.1297 9.99983 14.1297C10.7598 14.1297 10.8841 13.6333 10.9089 13.2406L11.5277 7.57759C11.6016 6.62607 10.7598 6.03638 9.99983 6.03638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 17.3903C10.6122 17.3903 11.109 16.8935 11.109 16.2806C11.109 15.6677 10.6122 15.1709 9.99935 15.1709C9.38648 15.1709 8.88965 15.6677 8.88965 16.2806C8.88965 16.8935 9.38648 17.3903 9.99935 17.3903Z",
    fill: "white"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V16.6668C2.5 17.5873 3.24619 18.3335 4.16667 18.3335H15.8333C16.7538 18.3335 17.5 17.5873 17.5 16.6668V5.00016C17.5 4.07969 16.7538 3.3335 15.8333 3.3335Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 1.6665V4.99984",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 1.6665V4.99984",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.3335H17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "tablet",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28076 11.3312V43.5912C9.28076 44.7614 10.2332 45.7134 11.404 45.7134H38.5989C39.7682 45.7134 40.7193 44.7613 40.7193 43.5912V11.3312C40.7193 9.7125 39.4016 8.39551 37.7818 8.39551H12.2184C10.5985 8.39551 9.28076 9.7124 9.28076 11.3312ZM38.7497 11.3312V43.5912C38.7497 43.6738 38.6806 43.7437 38.5988 43.7437H11.4039C11.322 43.7437 11.2502 43.6724 11.2502 43.5912V11.3312C11.2502 10.7985 11.6844 10.3652 12.2182 10.3652H37.7816C38.3155 10.3652 38.7497 10.7985 38.7497 11.3312Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6965 37.7773C29.2403 37.7773 29.6813 37.3364 29.6813 36.7925C29.6813 36.2485 29.2403 35.8076 28.6965 35.8076H21.3036C20.7598 35.8076 20.3188 36.2485 20.3188 36.7925C20.3188 37.3364 20.7598 37.7773 21.3036 37.7773H28.6965Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8184 39.7119H19.182C18.6382 39.7119 18.1973 40.1528 18.1973 40.6968C18.1973 41.2407 18.6382 41.6816 19.182 41.6816H30.8184C31.3622 41.6816 31.8031 41.2407 31.8031 40.6968C31.8031 40.1528 31.3622 39.7119 30.8184 39.7119Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3973 6.16748C29.9411 6.16748 30.382 5.72656 30.382 5.18262C30.382 4.63867 29.9411 4.19775 29.3973 4.19775H29.3778C28.834 4.19775 28.3931 4.63867 28.3931 5.18262C28.3931 5.72656 28.834 6.16748 29.3778 6.16748H29.3973Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0016 6.16748C25.5454 6.16748 25.9863 5.72656 25.9863 5.18262C25.9863 4.63867 25.5454 4.19775 25.0016 4.19775H20.6029C20.0591 4.19775 19.6182 4.63867 19.6182 5.18262C19.6182 5.72656 20.0591 6.16748 20.6029 6.16748H25.0016Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76992 18.1826C6.31377 18.1826 6.75469 17.7417 6.75469 17.1978V17.1812C6.75469 16.6372 6.31377 16.1963 5.76992 16.1963C5.22607 16.1963 4.78516 16.6372 4.78516 17.1812V17.1978C4.78516 17.7417 5.22607 18.1826 5.76992 18.1826Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7123 0H9.2877C6.80498 0 4.78516 2.01836 4.78516 4.49922V12.8063C4.78516 13.3502 5.22607 13.7912 5.76992 13.7912C6.31377 13.7912 6.75469 13.3502 6.75469 12.8063V4.49922C6.75469 3.10439 7.89102 1.96973 9.2877 1.96973H40.7122C42.1089 1.96973 43.2452 3.10449 43.2452 4.49922V45.5008C43.2452 46.8956 42.1089 48.0303 40.7122 48.0303H9.2877C7.89102 48.0303 6.75469 46.8955 6.75469 45.5008V21.5729C6.75469 21.0289 6.31377 20.588 5.76992 20.588C5.22607 20.588 4.78516 21.0289 4.78516 21.5729V45.5008C4.78516 47.9816 6.80498 50 9.2877 50H40.7122C43.195 50 45.2148 47.9816 45.2148 45.5008V4.49922C45.2148 2.01836 43.195 0 40.7123 0Z",
    fill: "#C17E7E"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "module",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3357 9.90388C20.5157 10.0842 20.7522 10.1742 20.9884 10.1742C21.2246 10.1742 21.4608 10.0842 21.6408 9.90388L24.5602 6.9851C24.9202 6.62448 24.9202 6.03998 24.5602 5.67964C24.1999 5.31902 23.6154 5.31902 23.255 5.67964L20.3357 8.59871C19.9753 8.95933 19.9753 9.54384 20.3357 9.90388Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1929 9.90388C25.3732 10.0842 25.6091 10.1742 25.845 10.1742C26.0815 10.1742 26.3174 10.0842 26.4977 9.90388L29.4171 6.9851C29.7777 6.62448 29.7777 6.03998 29.4171 5.67964C29.0568 5.31902 28.4723 5.31902 28.1116 5.67964L25.1926 8.59871C24.8322 8.95933 24.8322 9.54384 25.1929 9.90388Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3056 37.2757H43.0403V34.2119C43.0403 33.7025 42.6266 33.2889 42.1172 33.2889H38.6483V31.1899H41.914C42.6771 31.1899 43.2983 30.5693 43.2983 29.8056V21.4285C43.2983 20.6654 42.6771 20.0443 41.914 20.0443H38.6483V17.0544C38.6483 16.5444 38.235 16.1313 37.7253 16.1313H25.8535V14.0364H32.5588C33.3523 14.0364 33.9981 13.3906 33.9981 12.5965V2.98649C33.9981 2.19272 33.3523 1.54688 32.5588 1.54688H28.4782C27.9682 1.54688 27.5551 1.95995 27.5551 2.46992C27.5551 2.97961 27.9682 3.39297 28.4782 3.39297H32.1526V12.1903H17.7095V3.39297H21.0731C21.5828 3.39297 21.9962 2.97961 21.9962 2.46992C21.9962 1.95995 21.5828 1.54688 21.0731 1.54688H17.3027C16.5092 1.54688 15.8634 2.19272 15.8634 2.98649V12.5965C15.8634 13.3906 16.5092 14.0364 17.3027 14.0364H24.008V16.1313H11.6472C11.1375 16.1313 10.7241 16.5444 10.7241 17.0544V20.0443H7.45875C6.69508 20.0443 6.07417 20.6654 6.07417 21.4285V29.8056C6.07417 30.5693 6.69508 31.1899 7.45875 31.1899H10.7241V33.2889H7.87383C7.36386 33.2889 6.95078 33.7025 6.95078 34.2119V37.2757H3.63526C2.8716 37.2757 2.25098 37.8969 2.25098 38.66V47.0371C2.25098 47.8008 2.8716 48.422 3.63526 48.422H12.0124C12.7754 48.422 13.3966 47.8008 13.3966 47.0371V38.66C13.3966 37.8969 12.7754 37.2757 12.0124 37.2757H8.79659V35.1347H24.008V37.2757H20.7974C20.0036 37.2757 19.358 37.9216 19.358 38.7156V46.9821C19.358 47.7761 20.0036 48.422 20.7974 48.422H21.2649C21.7746 48.422 22.188 48.0086 22.188 47.4989C22.188 46.9892 21.7746 46.5759 21.2649 46.5759H21.2039V39.1218H28.6579V46.5759H28.5934C28.0837 46.5759 27.6704 46.9892 27.6704 47.4989C27.6704 48.0086 28.0837 48.422 28.5934 48.422H29.0641C29.8579 48.422 30.5034 47.7761 30.5034 46.9821V38.7156C30.5034 37.9216 29.8579 37.2757 29.0641 37.2757H25.8535V35.1347H41.1942V37.2757H37.9285C37.1651 37.2757 36.5442 37.8969 36.5442 38.66V47.0371C36.5442 47.8008 37.1651 48.422 37.9285 48.422H46.3056C47.0687 48.422 47.6899 47.8008 47.6899 47.0371V38.66C47.6899 37.8969 47.0687 37.2757 46.3056 37.2757ZM11.5505 39.1218V46.5759H4.0965V39.1218H11.5505ZM7.91999 29.3444V21.8903H15.374V29.3444H7.91999ZM36.8025 33.2889H12.5702V31.1899H15.8358C16.5989 31.1899 17.2201 30.5693 17.2201 29.8056V21.4285C17.2201 20.6654 16.5989 20.0443 15.8358 20.0443H12.5702V17.9771H36.8025V20.0443H33.5369C32.7732 20.0443 32.1526 20.6654 32.1526 21.4285V29.8056C32.1526 30.5693 32.7732 31.1899 33.5369 31.1899H36.8025V33.2889ZM33.9981 29.3444V21.8903H41.4522V29.3444H33.9981ZM45.8438 46.5759H38.3898V39.1218H45.8438V46.5759Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2416 3.20529L24.2686 3.22564C24.4357 3.35263 24.6318 3.41427 24.8267 3.41427C25.105 3.41427 25.3805 3.28842 25.562 3.04935C25.8704 2.64344 25.7916 2.06495 25.3857 1.75622L25.3584 1.73558C24.9525 1.42713 24.3735 1.50596 24.0653 1.91216C23.7566 2.31779 23.8357 2.89656 24.2416 3.20529Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5023 46.7425L25.4756 46.7222C25.0697 46.414 24.4907 46.4929 24.1819 46.8988C23.8738 47.3047 23.9532 47.8837 24.3591 48.1922L24.3858 48.2128C24.5529 48.3395 24.749 48.4009 24.9433 48.4009C25.2222 48.4009 25.4977 48.275 25.6795 48.0362C25.9876 47.6298 25.9085 47.051 25.5023 46.7425Z",
    fill: "#C17E7E"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "parfume",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_19199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57978 12.5204C3.23115 11.5843 4.08711 10.9456 5.01621 10.679V10.036C5.01621 7.84873 6.79697 6.06924 8.98584 6.06924H21.648V5.9209C21.648 3.71992 23.44 1.9292 25.6427 1.9292H31.4959C33.6985 1.9292 35.4904 3.71982 35.4904 5.9209V10.212H36.9197C39.7639 10.212 42.0777 12.5241 42.0777 15.3659V18.4044C45.4279 21.898 47.2676 26.4679 47.2676 31.3199C47.2676 36.3093 45.3221 41.0008 41.7894 44.53C38.4729 47.8433 34.0673 49.7796 29.3842 49.9824C29.1104 49.9942 28.8376 50.0002 28.5647 50.0002C24.2015 50.0002 19.9926 48.489 16.6346 45.7005C16.2167 45.3535 16.1592 44.7335 16.5063 44.3156C16.8533 43.8977 17.4733 43.8401 17.8911 44.1873C24.5717 49.7346 34.248 49.2837 40.3994 43.1384C43.3935 40.1473 45.1122 36.2232 45.2853 32.0235C43.0786 31.3371 35.6479 29.4178 28.9511 32.227C28.1312 32.5708 27.3036 32.8472 26.4789 33.0702C26.4245 33.0901 26.3681 33.1054 26.3097 33.1155C24.1955 33.6683 22.1054 33.8627 20.2192 33.8627C18.8239 33.8627 17.5402 33.7572 16.4409 33.6143C14.5218 33.3647 12.9355 32.9799 11.8868 32.6808C12.0263 34.3674 12.4238 36.0514 13.0923 37.6761C13.2989 38.1784 13.0593 38.7531 12.5569 38.9599C12.0547 39.1664 11.4799 38.9267 11.2732 38.4245C8.44883 31.5587 9.93965 23.7474 15.0608 18.4044V15.3659C15.0608 12.524 17.3747 10.212 20.2188 10.212H21.6481V8.03623H8.98594C7.88164 8.03623 6.9832 8.9333 6.9832 10.0359V10.679C7.91211 10.9457 8.76778 11.5845 9.41856 12.5208C10.2312 13.6899 10.6786 15.2232 10.6786 16.8382C10.6786 18.4543 10.2312 19.9884 9.41865 21.1578C8.54316 22.4179 7.29707 23.1407 5.99981 23.1407C4.70254 23.1407 3.45596 22.4182 2.57978 21.1582C1.76621 19.9885 1.31816 18.4542 1.31816 16.8382C1.31807 15.2233 1.76611 13.6899 2.57978 12.5204ZM40.698 29.0257C42.613 29.2748 44.1966 29.6584 45.2453 29.9573C44.9388 26.1396 43.348 22.582 40.6805 19.7893H31.9808V29.2563C35.2509 28.5906 38.3835 28.7247 40.698 29.0257ZM30.0139 29.7555V19.7894H27.1248V30.8186C27.4814 30.6958 27.8369 30.5613 28.1902 30.4132C28.7953 30.1593 29.4046 29.9421 30.0139 29.7555ZM11.8447 30.6138C13.7125 31.1958 19.3776 32.6779 25.1578 31.3753V19.7894H16.4588C13.599 22.7846 12.0111 26.6419 11.8447 30.6138ZM17.0276 15.3659V17.8223H40.1109V15.3659C40.1109 13.6086 38.6794 12.179 36.9198 12.179H20.2188C18.4592 12.179 17.0276 13.6087 17.0276 15.3659ZM33.5236 10.212V8.03623H31.3437C30.8005 8.03623 30.3602 7.5959 30.3602 7.05273C30.3602 6.50957 30.8005 6.06924 31.3437 6.06924H33.5236V5.9209C33.5236 4.80449 32.6141 3.89629 31.496 3.89629H25.6428C24.5247 3.89629 23.6151 4.80449 23.6151 5.9209V10.212H33.5236ZM5.99971 21.1736C7.46973 21.1736 8.71162 19.1883 8.71162 16.8382C8.71162 14.4896 7.46973 12.5056 5.99971 12.5056C4.52822 12.5056 3.28506 14.4896 3.28506 16.8382C3.28506 19.1883 4.52822 21.1736 5.99971 21.1736Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6986 8.03584H44.3495C43.8063 8.03584 43.366 7.59551 43.366 7.05234C43.366 6.50918 43.8063 6.06885 44.3495 6.06885H47.6986C48.2418 6.06885 48.6821 6.50918 48.6821 7.05234C48.6821 7.59551 48.2418 8.03584 47.6986 8.03584Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0252 11.9923C43.5743 11.6894 43.4543 11.0784 43.7572 10.6276C44.06 10.1768 44.6712 10.0566 45.1219 10.3596L48.0223 12.3077C48.4732 12.6106 48.5932 13.2216 48.2903 13.6724C48.1005 13.955 47.7897 14.1077 47.473 14.1077C47.2844 14.1077 47.0938 14.0535 46.9255 13.9405L44.0252 11.9923Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0223 1.80004L45.122 3.74828C44.9538 3.86136 44.7631 3.91547 44.5746 3.91547C44.258 3.91547 43.9471 3.76283 43.7573 3.48021C43.4544 3.02933 43.5744 2.4183 44.0253 2.11547L46.9255 0.167224C47.3763 -0.135706 47.9875 -0.0156863 48.2903 0.435193C48.5932 0.886072 48.4732 1.49711 48.0223 1.80004Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7845 41.0311C14.2366 40.7302 14.8472 40.8526 15.1482 41.3048L15.1593 41.3215C15.4603 41.7736 15.3378 42.3842 14.8857 42.6852C14.7181 42.7967 14.5288 42.8501 14.3415 42.8501C14.0236 42.8501 13.7113 42.696 13.5219 42.4115L13.5108 42.3948C13.2098 41.9426 13.3323 41.3321 13.7845 41.0311Z",
    fill: "#C17E7E"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_19199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "matrix(-1 0 0 1 50 0)"
  }))))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.95825 9.5H15.0416",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.9585L15.0417 9.50016L9.5 15.0418",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "destroy",
    viewBox: "0 0 12 17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86333 8.30267C4.57044 8.00978 4.09556 8.00978 3.80267 8.30267C3.50978 8.59556 3.50978 9.07044 3.80267 9.36333L4.86333 8.30267ZM5.46967 11.0303C5.76256 11.3232 6.23744 11.3232 6.53033 11.0303C6.82322 10.7374 6.82322 10.2626 6.53033 9.96967L5.46967 11.0303ZM3.80267 11.6367C3.50978 11.9296 3.50978 12.4044 3.80267 12.6973C4.09556 12.9902 4.57044 12.9902 4.86333 12.6973L3.80267 11.6367ZM6.53033 11.0303C6.82322 10.7374 6.82322 10.2626 6.53033 9.96967C6.23744 9.67678 5.76256 9.67678 5.46967 9.96967L6.53033 11.0303ZM8.19733 9.36333C8.49022 9.07044 8.49022 8.59556 8.19733 8.30267C7.90444 8.00978 7.42956 8.00978 7.13667 8.30267L8.19733 9.36333ZM5.46967 9.96967C5.17678 10.2626 5.17678 10.7374 5.46967 11.0303C5.76256 11.3232 6.23744 11.3232 6.53033 11.0303L5.46967 9.96967ZM7.13667 12.6973C7.42956 12.9902 7.90444 12.9902 8.19733 12.6973C8.49022 12.4044 8.49022 11.9296 8.19733 11.6367L7.13667 12.6973ZM6.53033 9.96967C6.23744 9.67678 5.76256 9.67678 5.46967 9.96967C5.17678 10.2626 5.17678 10.7374 5.46967 11.0303L6.53033 9.96967ZM7.762 2.25C8.17621 2.25 8.512 1.91421 8.512 1.5C8.512 1.08579 8.17621 0.75 7.762 0.75V2.25ZM4.429 0.75C4.01479 0.75 3.679 1.08579 3.679 1.5C3.679 1.91421 4.01479 2.25 4.429 2.25V0.75ZM11 4.25C11.4142 4.25 11.75 3.91421 11.75 3.5C11.75 3.08579 11.4142 2.75 11 2.75V4.25ZM1 2.75C0.585786 2.75 0.25 3.08579 0.25 3.5C0.25 3.91421 0.585786 4.25 1 4.25V2.75ZM1.73223 14.7678L1.2019 15.2981L1.2019 15.2981L1.73223 14.7678ZM1 13H1.75H1ZM3.80267 9.36333L5.46967 11.0303L6.53033 9.96967L4.86333 8.30267L3.80267 9.36333ZM4.86333 12.6973L6.53033 11.0303L5.46967 9.96967L3.80267 11.6367L4.86333 12.6973ZM7.13667 8.30267L5.46967 9.96967L6.53033 11.0303L8.19733 9.36333L7.13667 8.30267ZM8.19733 11.6367L6.53033 9.96967L5.46967 11.0303L7.13667 12.6973L8.19733 11.6367ZM7.762 0.75H4.429V2.25H7.762V0.75ZM11 2.75H1V4.25H11V2.75ZM1.833 6.25H10.167V4.75H1.833V6.25ZM10.167 6.25C10.2128 6.25 10.25 6.28716 10.25 6.333H11.75C11.75 5.45873 11.0413 4.75 10.167 4.75V6.25ZM10.25 6.333V13H11.75V6.333H10.25ZM10.25 13C10.25 13.9665 9.4665 14.75 8.5 14.75V16.25C10.2949 16.25 11.75 14.7949 11.75 13H10.25ZM8.5 14.75H3.5V16.25H8.5V14.75ZM3.5 14.75C3.03587 14.75 2.59075 14.5656 2.26256 14.2374L1.2019 15.2981C1.8114 15.9076 2.63805 16.25 3.5 16.25V14.75ZM2.26256 14.2374C1.93437 13.9092 1.75 13.4641 1.75 13H0.25C0.25 13.862 0.59241 14.6886 1.2019 15.2981L2.26256 14.2374ZM1.75 13V6.333H0.25V13H1.75ZM1.75 6.333C1.75 6.28716 1.78716 6.25 1.833 6.25V4.75C0.958733 4.75 0.25 5.45873 0.25 6.333H1.75Z",
    fill: "#C17E7E"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "whiffs-total",
    viewBox: "0 0 22 25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22245 7.92418C8.61654 7.92418 9.94356 8.21572 11.1466 8.7401V3.95658C11.1466 3.23019 10.5578 2.64136 9.83142 2.64136H4.5706C3.84421 2.64136 3.25537 3.23019 3.25537 3.95658V8.75905C4.46981 8.22271 5.81185 7.92418 7.22245 7.92418Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.092H14.4454V25H0V19.092Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.120117 16.4616H14.3256C13.7056 13.105 10.7568 10.5547 7.22334 10.5547C3.68902 10.5546 0.740044 13.1049 0.120117 16.4616Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1249 5.27181C15.8129 5.27181 16.4719 4.66691 16.4402 3.95658C16.4083 3.24399 15.8622 2.64136 15.1249 2.64136C14.437 2.64136 13.7779 3.24626 13.8097 3.95658C13.8417 4.66918 14.3876 5.27181 15.1249 5.27181Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4296 0C19.7416 0 19.0826 0.604904 19.1144 1.31523C19.1463 2.02782 19.6923 2.63045 20.4296 2.63045C21.1176 2.63045 21.7766 2.02555 21.7448 1.31523C21.713 0.602634 21.167 0 20.4296 0Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4296 5.28271C19.7416 5.28271 19.0826 5.88762 19.1144 6.59794C19.1463 7.31053 19.6923 7.91317 20.4296 7.91317C21.1176 7.91317 21.7766 7.30826 21.7448 6.59794C21.713 5.88535 21.167 5.28271 20.4296 5.28271Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "whiffs-left",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_6431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 9.37504C17.9688 6.57035 13.5781 1.56254 13.0781 1.04691C13.0049 0.966352 12.9156 0.901984 12.8161 0.857937C12.7165 0.813891 12.6089 0.791138 12.5 0.791138C12.3911 0.791138 12.2835 0.813891 12.1839 0.857937C12.0844 0.901984 11.9951 0.966352 11.9219 1.04691C11.4219 1.56254 7.03125 6.55473 7.03125 9.37504C7.03125 10.8254 7.60742 12.2164 8.63301 13.242C9.6586 14.2676 11.0496 14.8438 12.5 14.8438C13.9504 14.8438 15.3414 14.2676 16.367 13.242C17.3926 12.2164 17.9688 10.8254 17.9688 9.37504Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90625 12.7421C4.48438 13.1874 0.78125 17.1328 0.78125 19.5312C0.78125 20.7744 1.27511 21.9667 2.15419 22.8458C3.03326 23.7248 4.22555 24.2187 5.46875 24.2187C6.71195 24.2187 7.90424 23.7248 8.78331 22.8458C9.66239 21.9667 10.1562 20.7744 10.1562 19.5312C10.1562 17.1328 6.45312 13.1874 6.03125 12.7421C5.95837 12.6665 5.871 12.6064 5.77435 12.5653C5.6777 12.5242 5.57377 12.5031 5.46875 12.5031C5.36373 12.5031 5.2598 12.5242 5.16315 12.5653C5.0665 12.6064 4.97913 12.6665 4.90625 12.7421Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0937 12.7421C20.0209 12.6665 19.9335 12.6064 19.8369 12.5653C19.7402 12.5242 19.6363 12.5031 19.5312 12.5031C19.4262 12.5031 19.3223 12.5242 19.2256 12.5653C19.129 12.6064 19.0416 12.6665 18.9688 12.7421C18.5469 13.1874 14.8438 17.1328 14.8438 19.5312C14.8438 20.7744 15.3376 21.9667 16.2167 22.8458C17.0958 23.7248 18.288 24.2187 19.5312 24.2187C20.7745 24.2187 21.9667 23.7248 22.8458 22.8458C23.7249 21.9667 24.2188 20.7744 24.2188 19.5312C24.2188 17.1328 20.5156 13.1874 20.0937 12.7421Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_6431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  }))))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "whiffs-spent",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9844 15.125C21.9844 10.2109 14.2422 1.71877 13.3594 0.765619C12.9141 0.289064 12.0859 0.289064 11.6407 0.765619C10.7578 1.71877 3.01562 10.211 3.01562 15.125C3.01563 20.3516 7.26563 24.6094 12.5 24.6094C17.7344 24.6094 21.9844 20.3516 21.9844 15.125ZM9.77346 14.3672C8.50002 14.3672 7.86721 14.0625 7.21094 13.7422C6.7969 13.5468 6.36722 13.3359 5.78905 13.2031C6.97657 10.0469 10.3985 5.71876 12.5 3.32031C14.8438 5.99999 18.8359 11.0781 19.5313 14.25C18.9766 14.1406 18.5703 13.9453 18.1563 13.7422C17.4453 13.4062 16.711 13.0469 15.25 13.0469C13.7969 13.0469 13.0547 13.4062 12.3438 13.7422C11.6797 14.0625 11.0547 14.3672 9.77346 14.3672Z",
    fill: "#625F5A",
    fillOpacity: 0.7
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "analytics",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3092_18239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0277 17.0592H1.94082V0.972266C1.94082 0.437891 1.50293 0 0.972266 0C0.437891 0 0 0.437891 0 0.972266V18.0314C0 18.5621 0.437891 19 0.972266 19H18.0314C18.5658 19 19.0037 18.5621 19.0037 18.0277C19.0037 17.4934 18.5621 17.0592 18.0277 17.0592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3463 9.01393C11.8528 9.19576 11.2999 8.75787 10.8917 8.53893C9.57798 7.77818 7.89322 8.11217 6.98033 9.32936L3.84087 13.4782C3.51802 13.9049 3.60337 14.5172 4.03013 14.8401C4.45689 15.1629 5.0692 15.0776 5.39205 14.6508L8.5315 10.502C9.05474 9.75982 9.96021 10.1792 10.5502 10.5985C11.9493 11.4557 13.9309 10.9028 14.6991 9.45553L16.6696 5.89674L16.9739 6.869C17.1372 7.38482 17.6975 7.66686 18.2022 7.50729C18.718 7.344 19.0001 6.79479 18.8405 6.27896L17.8422 3.12838C17.6901 2.62369 17.1186 2.33795 16.6139 2.4901L13.4448 3.48834C12.2276 3.8483 12.8362 5.74459 14.0237 5.35494L14.8883 5.08033L12.9846 8.51666C12.851 8.75787 12.621 8.94713 12.3463 9.01393Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3092_18239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  }))))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "analytics-chart",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 20.2812H0.859375C0.384742 20.2812 0 20.666 0 21.1406C0 21.6153 0.384742 22 0.859375 22H21.1406C21.6153 22 22 21.6153 22 21.1406C22 20.666 21.6153 20.2812 21.1406 20.2812Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70312 15.9844V14.2656C6.70312 12.844 5.54658 11.6875 4.125 11.6875C2.70342 11.6875 1.54688 12.844 1.54688 14.2656V15.9844C1.54688 17.406 2.70342 18.5625 4.125 18.5625C5.54658 18.5625 6.70312 17.406 6.70312 15.9844ZM3.26562 15.9844V14.2656C3.26562 13.7918 3.65114 13.4062 4.125 13.4062C4.59886 13.4062 4.98438 13.7918 4.98438 14.2656V15.9844C4.98438 16.4582 4.59886 16.8438 4.125 16.8438C3.65114 16.8438 3.26562 16.4582 3.26562 15.9844Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5781 15.9844V12.5469C13.5781 11.1253 12.4216 9.96875 11 9.96875C9.57842 9.96875 8.42188 11.1253 8.42188 12.5469V15.9844C8.42188 17.406 9.57842 18.5625 11 18.5625C12.4216 18.5625 13.5781 17.406 13.5781 15.9844ZM10.1406 15.9844V12.5469C10.1406 12.073 10.5261 11.6875 11 11.6875C11.4739 11.6875 11.8594 12.073 11.8594 12.5469V15.9844C11.8594 16.4582 11.4739 16.8438 11 16.8438C10.5261 16.8438 10.1406 16.4582 10.1406 15.9844Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4531 15.9844V9.10938C20.4531 7.6878 19.2966 6.53125 17.875 6.53125C16.4534 6.53125 15.2969 7.6878 15.2969 9.10938V15.9844C15.2969 17.406 16.4534 18.5625 17.875 18.5625C19.2966 18.5625 20.4531 17.406 20.4531 15.9844ZM17.0156 15.9844V9.10938C17.0156 8.63552 17.4011 8.25 17.875 8.25C18.3489 8.25 18.7344 8.63552 18.7344 9.10938V15.9844C18.7344 16.4582 18.3489 16.8438 17.875 16.8438C17.4011 16.8438 17.0156 16.4582 17.0156 15.9844Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3228 7.34572L18.7344 2.93412V4.29687C18.7344 4.77151 19.1191 5.15625 19.5937 5.15625C20.0684 5.15625 20.4531 4.77151 20.4531 4.29687V0.859375C20.4531 0.858086 20.4529 0.856883 20.4529 0.855594C20.4507 0.374387 20.0567 0 19.5937 0H16.1562C15.6816 0 15.2969 0.384742 15.2969 0.859375C15.2969 1.33401 15.6816 1.71875 16.1562 1.71875H17.519L13.1074 6.13035C12.8188 6.41901 12.3628 6.46422 12.023 6.23773L9.21158 4.36343C8.19253 3.6841 6.82449 3.81953 5.95846 4.68557L1.79856 8.84546C1.46298 9.18109 1.46298 9.7252 1.79856 10.0608C2.13415 10.3964 2.67831 10.3964 3.01394 10.0608L7.17383 5.9009C7.46245 5.61228 7.91852 5.56707 8.25819 5.79352L11.0696 7.66782C12.0886 8.34715 13.4567 8.21167 14.3228 7.34572Z",
    fill: "#C17E7E"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "monitoring-ico",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6072_8024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 15.0417H2.375C1.06875 15.0417 0 13.973 0 12.6667V3.16675C0 1.8605 1.06875 0.791748 2.375 0.791748H16.625C17.9312 0.791748 19 1.8605 19 3.16675V12.6667C19 13.973 17.9312 15.0417 16.625 15.0417ZM2.375 2.37508C1.93958 2.37508 1.58333 2.73133 1.58333 3.16675V12.6667C1.58333 13.1022 1.93958 13.4584 2.375 13.4584H16.625C17.0604 13.4584 17.4167 13.1022 17.4167 12.6667V3.16675C17.4167 2.73133 17.0604 2.37508 16.625 2.37508H2.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 18.2083H3.16667C2.73125 18.2083 2.375 17.8521 2.375 17.4167C2.375 16.9813 2.73125 16.625 3.16667 16.625H15.8333C16.2688 16.625 16.625 16.9813 16.625 17.4167C16.625 17.8521 16.2688 18.2083 15.8333 18.2083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12496 11.8751C7.12496 11.8751 7.10121 11.8751 7.08538 11.8751C6.80038 11.8592 6.53913 11.693 6.41246 11.4397L5.05079 8.7084H3.95829C3.52288 8.7084 3.16663 8.35215 3.16663 7.91674C3.16663 7.48132 3.52288 7.12507 3.95829 7.12507H5.54163C5.84246 7.12507 6.11954 7.29132 6.24621 7.56049L7.19621 9.4684L10.4025 4.33049C10.537 4.10882 10.7825 3.96632 11.0437 3.9584C11.305 3.95049 11.5583 4.06132 11.7087 4.27507L13.8462 7.12507H15.0337C15.4691 7.12507 15.8254 7.48132 15.8254 7.91674C15.8254 8.35215 15.4691 8.7084 15.0337 8.7084H13.4504C13.205 8.7084 12.9675 8.58965 12.817 8.39174L11.1387 6.15132L7.78996 11.503C7.64746 11.7326 7.39413 11.8751 7.11704 11.8751H7.12496Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6072_8024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  }))))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "monitoring-ico-brown",
    color: "#c17e7e",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6072_8024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 15.0417H2.375C1.06875 15.0417 0 13.973 0 12.6667V3.16675C0 1.8605 1.06875 0.791748 2.375 0.791748H16.625C17.9312 0.791748 19 1.8605 19 3.16675V12.6667C19 13.973 17.9312 15.0417 16.625 15.0417ZM2.375 2.37508C1.93958 2.37508 1.58333 2.73133 1.58333 3.16675V12.6667C1.58333 13.1022 1.93958 13.4584 2.375 13.4584H16.625C17.0604 13.4584 17.4167 13.1022 17.4167 12.6667V3.16675C17.4167 2.73133 17.0604 2.37508 16.625 2.37508H2.375Z",
    fill: "#c17e7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 18.2083H3.16667C2.73125 18.2083 2.375 17.8521 2.375 17.4167C2.375 16.9813 2.73125 16.625 3.16667 16.625H15.8333C16.2688 16.625 16.625 16.9813 16.625 17.4167C16.625 17.8521 16.2688 18.2083 15.8333 18.2083Z",
    fill: "#c17e7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12496 11.8751C7.12496 11.8751 7.10121 11.8751 7.08538 11.8751C6.80038 11.8592 6.53913 11.693 6.41246 11.4397L5.05079 8.7084H3.95829C3.52288 8.7084 3.16663 8.35215 3.16663 7.91674C3.16663 7.48132 3.52288 7.12507 3.95829 7.12507H5.54163C5.84246 7.12507 6.11954 7.29132 6.24621 7.56049L7.19621 9.4684L10.4025 4.33049C10.537 4.10882 10.7825 3.96632 11.0437 3.9584C11.305 3.95049 11.5583 4.06132 11.7087 4.27507L13.8462 7.12507H15.0337C15.4691 7.12507 15.8254 7.48132 15.8254 7.91674C15.8254 8.35215 15.4691 8.7084 15.0337 8.7084H13.4504C13.205 8.7084 12.9675 8.58965 12.817 8.39174L11.1387 6.15132L7.78996 11.503C7.64746 11.7326 7.39413 11.8751 7.11704 11.8751H7.12496Z",
    fill: "#c17e7e"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6072_8024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  }))))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "pin",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3624 7.85682C19.9836 6.26964 19.1603 4.82329 17.989 3.68725C16.8176 2.5512 15.3468 1.77253 13.7487 1.44246C12.1866 1.10936 10.5629 1.21342 9.0561 1.74321C7.54929 2.273 6.21772 3.208 5.2078 4.44542C4.19788 5.68285 3.5487 7.17478 3.33163 8.75719C3.11456 10.3396 3.33801 11.9512 3.97742 13.4149C4.20803 13.9443 4.4942 14.4477 4.83112 14.9166L8.86051 21.9584C9.1676 22.5004 9.61387 22.9504 10.1532 23.2621C10.6925 23.5738 11.3053 23.7358 11.9282 23.7314C12.5517 23.7351 13.1649 23.572 13.7042 23.2592C14.2436 22.9463 14.6895 22.495 14.9959 21.952L18.9661 15.0015C19.3078 14.5349 19.5971 14.0322 19.8288 13.5023L19.8365 13.4895C19.8579 13.4531 19.8768 13.4153 19.8931 13.3763C20.6427 11.6357 20.8073 9.69897 20.3624 7.85682ZM18.1407 12.5766C18.1321 12.591 18.1248 12.606 18.1188 12.6216C17.9092 13.0931 17.6506 13.5413 17.3474 13.9588L13.3219 20.9941C13.1814 21.24 12.9785 21.4443 12.7336 21.5864C12.4888 21.7285 12.2107 21.8034 11.9275 21.8034C11.6444 21.8034 11.3663 21.7285 11.1215 21.5864C10.8766 21.4443 10.6736 21.24 10.5332 20.9941L6.44853 13.8675C6.16656 13.475 5.92654 13.0539 5.7324 12.6113C5.28735 11.5829 5.10536 10.4598 5.20284 9.34346C5.30032 8.2271 5.67421 7.15257 6.29077 6.21682C6.90733 5.28107 7.74716 4.51355 8.73449 3.98351C9.72182 3.45346 10.8256 3.17757 11.9462 3.18073C12.4213 3.1811 12.8951 3.22934 13.3605 3.32473C14.5949 3.59053 15.7299 4.19778 16.6359 5.07727C17.542 5.95677 18.1828 7.07312 18.4853 8.2991C18.8311 9.72509 18.7103 11.2244 18.1407 12.5766ZM11.9282 6.39241C11.2289 6.39241 10.5453 6.59977 9.96387 6.98828C9.38243 7.37678 8.92926 7.92898 8.66165 8.57504C8.39404 9.2211 8.32403 9.93201 8.46045 10.6179C8.59687 11.3037 8.93362 11.9337 9.42809 12.4282C9.92256 12.9227 10.5526 13.2594 11.2384 13.3958C11.9243 13.5323 12.6352 13.4622 13.2812 13.1946C13.9273 12.927 14.4795 12.4738 14.868 11.8924C15.2565 11.311 15.4639 10.6274 15.4639 9.92809C15.4632 8.99058 15.0905 8.09166 14.4275 7.42874C13.7646 6.76582 12.8657 6.39309 11.9282 6.39241ZM11.9282 11.5352C11.6103 11.5352 11.2996 11.441 11.0353 11.2644C10.771 11.0878 10.565 10.8368 10.4434 10.5431C10.3218 10.2494 10.2899 9.9263 10.3519 9.61455C10.414 9.3028 10.567 9.01644 10.7918 8.79168C11.0165 8.56692 11.3029 8.41385 11.6147 8.35184C11.9264 8.28983 12.2495 8.32166 12.5432 8.4433C12.8369 8.56494 13.0879 8.77093 13.2645 9.03522C13.4411 9.29951 13.5353 9.61023 13.5353 9.92809C13.5346 10.3541 13.3651 10.7625 13.0638 11.0637C12.7626 11.365 12.3542 11.5345 11.9282 11.5352Z",
    fill: "black"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-store-offline-status-green",
    viewBox: "0 0 22 22",
    fill: "#00E58E",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2143 11.1268V19.5024C10.2143 19.9363 10.5661 20.2882 11 20.2882C11.4339 20.2882 11.7857 19.9363 11.7857 19.5024V11.124C12.1817 11.0004 12.5573 10.7937 12.8707 10.4805C13.9004 9.45006 13.9004 7.77389 12.8703 6.74418C11.8406 5.71369 10.164 5.71369 9.13431 6.74418C8.10094 7.77755 8.09407 9.45106 9.12933 10.4855C9.44229 10.7985 9.81798 11.0044 10.2143 11.1268ZM10.2454 7.85522C10.6627 7.43787 11.3418 7.4378 11.7592 7.85522C12.1767 8.27264 12.1763 8.95208 11.7592 9.36949C11.3391 9.79035 10.6582 9.79112 10.2404 9.37448C9.82297 8.95707 9.82527 8.27532 10.2454 7.85522Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5618 14.1536C16.2549 14.4605 16.2549 14.9577 16.5618 15.2647C16.8687 15.5716 17.3659 15.5716 17.6728 15.2647C21.3459 11.5916 21.3459 5.6151 17.6728 1.94204C17.3659 1.63512 16.8687 1.63512 16.5618 1.94204C16.2549 2.24896 16.2549 2.74617 16.5618 3.05309C19.6222 6.11346 19.6222 11.0932 16.5618 14.1536Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1605 12.8726C14.4674 13.1795 14.9646 13.1795 15.2715 12.8726C17.6233 10.5208 17.6233 6.69469 15.2715 4.34292C14.9646 4.036 14.4674 4.036 14.1605 4.34292C13.8536 4.64984 13.8536 5.14705 14.1605 5.45397C15.8996 7.19305 15.8996 10.0225 14.1605 11.7616C13.8536 12.0685 13.8536 12.5657 14.1605 12.8726Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43823 15.2647C5.74515 14.9577 5.74515 14.4605 5.43823 14.1536C2.37786 11.0932 2.37786 6.11346 5.43823 3.05309C5.74515 2.74617 5.74515 2.24896 5.43823 1.94204C5.13131 1.63512 4.6341 1.63512 4.32718 1.94204C0.654122 5.6151 0.654122 11.5916 4.32718 15.2647C4.63409 15.5716 5.1313 15.5716 5.43823 15.2647Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72845 12.8726C7.03536 13.1795 7.53257 13.1795 7.83949 12.8726C8.14641 12.5657 8.14641 12.0685 7.83949 11.7616C6.1008 10.0229 6.1008 7.19305 7.83949 5.45397C8.14641 5.14705 8.14641 4.64946 7.83949 4.34292C7.53258 4.036 7.03537 4.036 6.72845 4.34292C4.37706 6.69469 4.37706 10.5212 6.72845 12.8726Z",
    color: "inherit"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-store-offline-status-red",
    viewBox: "0 0 22 22",
    fill: "#FF4863",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2143 11.1268V19.5024C10.2143 19.9363 10.5661 20.2882 11 20.2882C11.4339 20.2882 11.7857 19.9363 11.7857 19.5024V11.124C12.1817 11.0004 12.5573 10.7937 12.8707 10.4805C13.9004 9.45006 13.9004 7.77389 12.8703 6.74418C11.8406 5.71369 10.164 5.71369 9.13431 6.74418C8.10094 7.77755 8.09407 9.45106 9.12933 10.4855C9.44229 10.7985 9.81798 11.0044 10.2143 11.1268ZM10.2454 7.85522C10.6627 7.43787 11.3418 7.4378 11.7592 7.85522C12.1767 8.27264 12.1763 8.95208 11.7592 9.36949C11.3391 9.79035 10.6582 9.79112 10.2404 9.37448C9.82297 8.95707 9.82527 8.27532 10.2454 7.85522Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5618 14.1536C16.2549 14.4605 16.2549 14.9577 16.5618 15.2647C16.8687 15.5716 17.3659 15.5716 17.6728 15.2647C21.3459 11.5916 21.3459 5.6151 17.6728 1.94204C17.3659 1.63512 16.8687 1.63512 16.5618 1.94204C16.2549 2.24896 16.2549 2.74617 16.5618 3.05309C19.6222 6.11346 19.6222 11.0932 16.5618 14.1536Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1605 12.8726C14.4674 13.1795 14.9646 13.1795 15.2715 12.8726C17.6233 10.5208 17.6233 6.69469 15.2715 4.34292C14.9646 4.036 14.4674 4.036 14.1605 4.34292C13.8536 4.64984 13.8536 5.14705 14.1605 5.45397C15.8996 7.19305 15.8996 10.0225 14.1605 11.7616C13.8536 12.0685 13.8536 12.5657 14.1605 12.8726Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43823 15.2647C5.74515 14.9577 5.74515 14.4605 5.43823 14.1536C2.37786 11.0932 2.37786 6.11346 5.43823 3.05309C5.74515 2.74617 5.74515 2.24896 5.43823 1.94204C5.13131 1.63512 4.6341 1.63512 4.32718 1.94204C0.654122 5.6151 0.654122 11.5916 4.32718 15.2647C4.63409 15.5716 5.1313 15.5716 5.43823 15.2647Z",
    color: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72845 12.8726C7.03536 13.1795 7.53257 13.1795 7.83949 12.8726C8.14641 12.5657 8.14641 12.0685 7.83949 11.7616C6.1008 10.0229 6.1008 7.19305 7.83949 5.45397C8.14641 5.14705 8.14641 4.64946 7.83949 4.34292C7.53258 4.036 7.03537 4.036 6.72845 4.34292C4.37706 6.69469 4.37706 10.5212 6.72845 12.8726Z",
    color: "inherit"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 25",
    fill: "#00E58E",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.46 8.4V1.308H8V0H14.516V1.308H12.068V8.4H10.46Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.41052,
    y: 13.0526,
    width: 14.9053,
    height: 6.31579,
    rx: 1,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-low-battery-stations-status-green",
    viewBox: "0 0 24 25",
    fill: "#00E58E",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.46 8.4V1.308H8V0H14.516V1.308H12.068V8.4H10.46Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.41052,
    y: 13.0526,
    width: 14.9053,
    height: 6.31579,
    rx: 1,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-low-battery-stations-status-red",
    viewBox: "0 0 24 25",
    fill: "#FF4863",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.46 8.4V1.308H8V0H14.516V1.308H12.068V8.4H10.46Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.41052,
    y: 13.0526,
    width: 14.9053,
    height: 6.31579,
    rx: 1,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-low-battery-devices-status-green",
    viewBox: "0 0 24 25",
    fill: "#00E58E",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8.4V0H11.712C12.688 0 13.492 0.172 14.124 0.516001C14.764 0.860001 15.236 1.348 15.54 1.98C15.852 2.604 16.008 3.348 16.008 4.212C16.008 5.06 15.852 5.8 15.54 6.432C15.236 7.056 14.764 7.54 14.124 7.884C13.492 8.228 12.688 8.4 11.712 8.4H9ZM10.44 7.176H11.64C12.368 7.176 12.94 7.06 13.356 6.828C13.78 6.588 14.08 6.248 14.256 5.808C14.44 5.36 14.532 4.828 14.532 4.212C14.532 3.588 14.44 3.056 14.256 2.616C14.08 2.168 13.78 1.824 13.356 1.584C12.94 1.336 12.368 1.212 11.64 1.212H10.44V7.176Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.41052,
    y: 13.0526,
    width: 14.9053,
    height: 6.31579,
    rx: 1,
    fill: "inherit"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-low-battery-devices-status-red",
    viewBox: "0 0 24 25",
    fill: "#FF4863",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8.4V0H11.712C12.688 0 13.492 0.172 14.124 0.516001C14.764 0.860001 15.236 1.348 15.54 1.98C15.852 2.604 16.008 3.348 16.008 4.212C16.008 5.06 15.852 5.8 15.54 6.432C15.236 7.056 14.764 7.54 14.124 7.884C13.492 8.228 12.688 8.4 11.712 8.4H9ZM10.44 7.176H11.64C12.368 7.176 12.94 7.06 13.356 6.828C13.78 6.588 14.08 6.248 14.256 5.808C14.44 5.36 14.532 4.828 14.532 4.212C14.532 3.588 14.44 3.056 14.256 2.616C14.08 2.168 13.78 1.824 13.356 1.584C12.94 1.336 12.368 1.212 11.64 1.212H10.44V7.176Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.709C22.0875 18.709 21.75 18.3715 21.75 17.959V14.4574C21.75 14.0449 22.0875 13.7074 22.5 13.7074C22.9125 13.7074 23.25 14.0449 23.25 14.4574V17.959C23.25 18.3762 22.9125 18.709 22.5 18.709Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1078 22.2105H3.64219C2.04844 22.2105 0.75 20.9121 0.75 19.3184V13.1027C0.75 11.509 2.04844 10.2105 3.64219 10.2105H18.1078C19.7016 10.2105 21 11.509 21 13.1027V19.3184C21 20.9121 19.7016 22.2105 18.1078 22.2105ZM3.64219 11.7105C2.87344 11.7105 2.25 12.334 2.25 13.1027V19.3184C2.25 20.0871 2.87344 20.7105 3.64219 20.7105H18.1078C18.8766 20.7105 19.5 20.0871 19.5 19.3184V13.1027C19.5 12.334 18.8766 11.7105 18.1078 11.7105H3.64219Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.41052,
    y: 13.0526,
    width: 14.9053,
    height: 6.31579,
    rx: 1,
    fill: "inherit"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-critical-level-chambers-devices-green",
    viewBox: "0 0 19 18",
    fill: "#00E58E",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6136_4689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18805 0.244652C3.04968 0.400331 2.98434 0.607643 3.00874 0.814469L4.5877 14.2435L4.95361 17.356C4.99669 17.7233 5.30795 18.0001 5.67784 18.0001H14.1435C14.5134 18.0001 14.8247 17.7233 14.8677 17.356L15.2337 14.2444L16.8125 0.814469C16.8369 0.607643 16.7716 0.400233 16.6332 0.244652C16.4948 0.0890704 16.2965 0 16.0883 0H3.73307C3.52479 0 3.32642 0.0890704 3.18805 0.244652ZM13.4949 16.5414H6.32642L6.13331 14.8985H13.6881L13.4949 16.5414ZM15.2682 1.45858L14.8677 3L4.95361 3L4.55308 1.45858H15.2682Z",
    fill: "inherit"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6136_4689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "inherit",
    transform: "translate(0.910645)"
  }))))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-critical-level-chambers-devices-red",
    viewBox: "0 0 19 18",
    fill: "#FF4863",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6136_4689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18805 0.244652C3.04968 0.400331 2.98434 0.607643 3.00874 0.814469L4.5877 14.2435L4.95361 17.356C4.99669 17.7233 5.30795 18.0001 5.67784 18.0001H14.1435C14.5134 18.0001 14.8247 17.7233 14.8677 17.356L15.2337 14.2444L16.8125 0.814469C16.8369 0.607643 16.7716 0.400233 16.6332 0.244652C16.4948 0.0890704 16.2965 0 16.0883 0H3.73307C3.52479 0 3.32642 0.0890704 3.18805 0.244652ZM13.4949 16.5414H6.32642L6.13331 14.8985H13.6881L13.4949 16.5414ZM15.2682 1.45858L14.8677 3L4.95361 3L4.55308 1.45858H15.2682Z",
    fill: "inherit"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6136_4689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "inherit",
    transform: "translate(0.910645)"
  }))))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-expired-license-devices-green",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7469 1H1.7716C1.34546 1 1 1.39797 1 1.88889V15.6666C1 16.1576 1.34546 16.5555 1.7716 16.5555H18.7469C19.1731 16.5555 19.5185 16.1576 19.5185 15.6666V1.88889C19.5185 1.39797 19.1731 1 18.7469 1Z",
    stroke: "#00E58E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5H16",
    stroke: "#00E58E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8H16",
    stroke: "#00E58E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11H10",
    stroke: "#00E58E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18C15.8807 18 17 16.8807 17 15.5C17 14.1193 15.8807 13 14.5 13C13.1193 13 12 14.1193 12 15.5C12 16.8807 13.1193 18 14.5 18Z",
    fill: "white",
    stroke: "#00E58E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.889 18.3333L13.1174 21",
    stroke: "#00E58E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1173 18.3333L15.8889 21",
    stroke: "#00E58E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "cluster-expired-license-devices-red",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7469 1H1.7716C1.34546 1 1 1.39797 1 1.88889V15.6666C1 16.1576 1.34546 16.5555 1.7716 16.5555H18.7469C19.1731 16.5555 19.5185 16.1576 19.5185 15.6666V1.88889C19.5185 1.39797 19.1731 1 18.7469 1Z",
    stroke: "#FF4863",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5H16",
    stroke: "#FF4863",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8H16",
    stroke: "#FF4863",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11H10",
    stroke: "#FF4863",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18C15.8807 18 17 16.8807 17 15.5C17 14.1193 15.8807 13 14.5 13C13.1193 13 12 14.1193 12 15.5C12 16.8807 13.1193 18 14.5 18Z",
    fill: "white",
    stroke: "#FF4863",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.889 18.3333L13.1174 21",
    stroke: "#FF4863",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1173 18.3333L15.8889 21",
    stroke: "#FF4863",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "archive",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83406 15.6664C9.65073 15.6664 9.37573 15.5748 9.28406 15.4831L6.53407 13.1914C6.1674 12.8248 6.07574 12.2748 6.4424 11.9081C6.80907 11.5414 7.35907 11.4498 7.72573 11.8164L9.92573 13.6498L12.1257 11.8164C12.4924 11.4498 13.1341 11.5414 13.4091 11.9081C13.7757 12.2748 13.6841 12.9164 13.3174 13.1914L10.5674 15.4831C10.2924 15.5748 10.0174 15.6664 9.83406 15.6664Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83414 15.6668C9.28415 15.6668 8.91748 15.3001 8.91748 14.7501V9.25016C8.91748 8.70016 9.28415 8.3335 9.83414 8.3335C10.3841 8.3335 10.7508 8.70016 10.7508 9.25016V14.7501C10.7508 15.2085 10.3841 15.6668 9.83414 15.6668Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5258 19.3336H3.14247C1.76748 19.3336 0.66748 18.2336 0.66748 16.8586V5.58366C0.66748 5.03366 1.03415 4.66699 1.58414 4.66699H18.0841C18.6341 4.66699 19.0008 5.03366 19.0008 5.58366V16.8586C19.0008 18.2336 17.9008 19.3336 16.5258 19.3336ZM2.50081 6.50032V16.8586C2.50081 17.2253 2.77581 17.5003 3.14247 17.5003H16.5258C16.8924 17.5003 17.1674 17.2253 17.1674 16.767V6.50032H2.50081Z",
    fill: "#C17E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0841 6.49999H1.58411C1.21744 6.49999 0.942445 6.31665 0.759112 5.94999C0.575779 5.58332 0.667445 5.30832 0.850778 5.03332L3.32577 1.73333C3.69244 1.275 4.24244 1 4.79244 1H14.8757C15.4257 1 15.9757 1.275 16.3424 1.73333L18.8174 5.03332C19.0007 5.30832 19.0924 5.67499 18.9091 5.94999C18.7257 6.31665 18.4507 6.49999 18.0841 6.49999ZM3.41744 4.66666H16.2507L14.8757 2.83333H4.79244L3.41744 4.66666Z",
    fill: "#C17E7E"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "usa",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_19657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 21.9996C17.075 21.9996 22 17.0742 22 10.9998C22 4.92541 17.0754 0 11.0002 0C4.92495 0 0.000396729 4.92584 0.000396729 10.9998C0.000396729 17.0737 4.92538 21.9996 11.0002 21.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3743 5.25627H10.5054V2.38387H17.8383C18.8453 3.18552 19.7036 4.15775 20.3743 5.25627ZM21.9998 10.9998H10.5115V8.12825H21.6212C21.8733 9.06459 22.0006 10.0301 21.9998 10.9998ZM11 21.9996C13.4868 22.0053 15.9012 21.1626 17.8444 19.6106H4.15608C6.09889 21.1628 8.51325 22.0056 11 21.9996ZM20.3863 16.7446H1.61366C1.06613 15.8517 0.650349 14.8844 0.379196 13.8726H21.6208C21.3497 14.8844 20.934 15.8517 20.3863 16.7446Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10713 1.71184H5.09725V1.71871L5.10713 1.71184ZM5.10713 1.71184H6.10184L5.16471 2.38428L5.5192 3.48426L4.58421 2.81181L3.65525 3.48426L3.96075 2.5351C3.13967 3.22231 2.42329 4.02569 1.83427 4.91982H2.15825L1.56529 5.3495L1.29631 5.82215L1.57732 6.69611L1.04581 6.3094L0.67929 7.16275L0.984792 8.12093H2.14493L1.22283 8.80025L1.57732 9.90023L0.642338 9.22778L0.0923486 9.63082C0.0309742 10.0846 0.000254113 10.5419 0.000397226 10.9998H11.0002V-5.99384e-06C8.91283 -0.00272076 6.86818 0.591219 5.10713 1.71184ZM5.51705 9.89465L5.52521 9.90109H5.5192L5.51705 9.89465ZM5.16428 8.80068L5.51705 9.89465L4.58379 9.22864L3.6488 9.90109L4.00329 8.80111L3.06831 8.12866H4.22844L4.58293 7.02869L4.93741 8.12866H6.09754L5.16428 8.80068ZM5.17073 5.59871L5.52521 6.69869L4.59023 6.02624L3.65525 6.69869L4.00973 5.59871L3.07475 4.92627H4.23489L4.58937 3.82629L4.94386 4.92627H6.10399L5.17073 5.59871ZM8.53769 9.22864L9.47267 9.90109L9.11819 8.80111L10.0549 8.12866H8.89476L8.54027 7.02869L8.18579 8.12866H7.02565L7.96063 8.80111L7.60615 9.90109L8.53769 9.22864ZM9.11819 5.59871L9.47267 6.69869L8.53769 6.02624L7.60271 6.69869L7.9572 5.59871L7.02221 4.92627H8.18235L8.53683 3.82629L8.89132 4.92627H10.0515L9.11819 5.59871ZM9.47267 3.49629L9.11819 2.39631L10.0549 1.72387H8.89476L8.54027 0.623888L8.18579 1.72387H7.02565L7.96063 2.39631L7.60615 3.49629L8.54113 2.82385L9.47267 3.49629Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_19657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  }))))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "spain",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_19658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45138e-06 11.0001C-0.00129612 12.306 0.230486 13.6017 0.684451 14.8262L11 15.7826L21.3156 14.8262C21.7695 13.6017 22.0013 12.306 22 11.0001C22.0013 9.69411 21.7695 8.39837 21.3156 7.17389L11 6.2175L0.684451 7.1745C0.230558 8.3988 -0.0012234 9.6943 5.45138e-06 11.0001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C15.73 0 19.7615 2.98528 21.3156 7.17444H0.684448C2.2385 2.98528 6.27 0 11 0ZM11 22C6.27 22 2.2385 19.0147 0.684448 14.8256H21.3156C19.7615 19.0147 15.73 22 11 22Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_19658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  }))))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "russia",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_19659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0745 22 22 17.0745 22 11C22 4.92551 17.0745 0 11 0C4.92551 0 0 4.92551 0 11C0 17.0745 4.92551 22 11 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3155 14.8242C22.2282 12.3555 22.2282 9.64189 21.3155 7.1732H0.684497C-0.228166 9.64189 -0.228166 12.3555 0.684497 14.8242L11 15.7854L21.3155 14.8242Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22C15.73 22 19.7631 19.018 21.3155 14.8242H0.684494C2.23867 19.018 6.27 22 11 22Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_19659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  }))))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "israel",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_19656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8475 2.39133H4.15862C3.15207 3.19294 2.2932 4.16411 1.62067 5.26111H20.3867C19.714 4.16418 18.8552 3.19303 17.8487 2.39133H17.8475ZM12.3811 8.60879H15.1421H15.1433L13.7622 11.0001L15.1421 13.3913H12.3811L11 15.7826L9.62012 13.3913H6.8579L8.23901 11.0001L6.85667 8.60879H9.6189L11 6.21751L12.3811 8.60879ZM11.8482 12.4692L12.6965 11.0001L11.8488 9.53095H10.1524L9.30417 11.0001L10.1518 12.4692H11.8482ZM11 8.06184L11.316 8.60879H10.6847L11 8.06184ZM9.08723 9.53095H8.45595H8.45534L8.77129 10.0779L9.08723 9.53095ZM8.45595 12.4692L8.7719 11.9222L9.08784 12.4692H8.45656H8.45595ZM10.6847 13.3913L11 13.9383L11.316 13.3913H10.6847ZM13.5441 12.4692H12.9128L13.2287 11.9222L13.5441 12.4692ZM13.5441 9.53095H12.9128H12.9122L13.2281 10.0779L13.5441 9.53095ZM17.842 19.6088H4.15312H4.15251C3.14604 18.8071 2.28718 17.836 1.61456 16.739H20.38C19.7074 17.836 18.8486 18.8072 17.842 19.6088Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_19656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.1c677d9a5f4e6c2aac32ce15668e980a.svg";
export { ForwardRef as ReactComponent };